import { pendo } from '@frontend/tracking';

type ScheduleVersionState = 'v2' | 'v3';

const SCHEDULE_VERSION_STATE_LOCAL_STORAGE_KEY = 'weave.schedule-version-changed';

// Need to ignore endpoints which were used in both v2 and v3
const IGNORED_ENDPOINTS = ['ListSourceTenants'];

const trackScheduleAPIVersionChange = (version: ScheduleVersionState, changeEventMetadata?: pendo.Metadata) => {
  const currentValue = localStorage.getItem(SCHEDULE_VERSION_STATE_LOCAL_STORAGE_KEY);

  const shouldIgnore = IGNORED_ENDPOINTS.includes((changeEventMetadata?.endpoint || '') as string);
  if (shouldIgnore) {
    // If the endpoint is in the ignored list, we do not track the change.
    return;
  }

  if (currentValue === version) {
    // If the current value is already the same as the version, we do not need to track it again.
    return;
  }

  if (currentValue !== version) {
    localStorage.setItem(SCHEDULE_VERSION_STATE_LOCAL_STORAGE_KEY, version);

    // Track the event only if the current value is not null or undefined
    if (currentValue) {
      pendo.track('schedule:api-version-changed', { version, ...changeEventMetadata });
    }
  }
};

export { trackScheduleAPIVersionChange };
